import { useFormContext } from 'react-hook-form';
import type { TLocalize } from '@hooks/use-localize';
import type { IHistoryDemographicsFormValues } from '@/types/history/history-demographics';
import FieldError from '@components/field-error';

interface IInsurancePhysicianSectionProps {
    t: TLocalize;
}

/** Health insurance and primary care physician. */
const InsurancePhysicianSection = ({ t }: IInsurancePhysicianSectionProps) => {
    const {
        register,
        watch,
        formState: { errors },
    } = useFormContext<IHistoryDemographicsFormValues>();

    const hasPrimaryCarePhysician = watch('hasPrimaryCarePhysician') === '1';

    return (
        <>
            <div className='section-heading'>Insurance & Physician</div>

            <div className="form-group">
                <label className="control-label col-xs-12">
                    {t('DashLabel_DoYouHaveHealthInsurance', 'Do you have health insurance')}?
                    <FieldError message={errors.hasHealthInsurance?.message} />
                </label>
                <div className="col-xs-12 col-md-8">
                    <label className="radio-inline">
                        <input type="radio" value="1" {...register('hasHealthInsurance')} />{' '}
                        {t('Word_Yes', 'Yes')}
                    </label>
                    <label className="radio-inline">
                        <input type="radio" value="0" {...register('hasHealthInsurance')} />{' '}
                        {t('Word_No', 'No')}
                    </label>
                </div>
            </div>

            <div className="form-group">
                <label className="control-label col-xs-12">
                    {t('DashLabel_DoYouHaveAPrimaryCarePhysician', 'Do you have a primary care physician')}?
                    <FieldError message={errors.hasPrimaryCarePhysician?.message} />
                </label>
                <div className="col-xs-12">
                    <label className="radio-inline">
                        <input type="radio" value="1" {...register('hasPrimaryCarePhysician')} />{' '}
                        {t('Word_Yes', 'Yes')}
                    </label>
                    <label className="radio-inline">
                        <input type="radio" value="0" {...register('hasPrimaryCarePhysician')} />{' '}
                        {t('Word_No', 'No')}
                    </label>
                </div>
            </div>

            {hasPrimaryCarePhysician && (
                <div className="sub-question">
                    <div className="form-group">
                        <label className="control-label col-xs-12">
                            {t('DashLabel_PhysicianSName', "Physician's name")}:
                        </label>
                        <div className="col-xs-12 col-md-8">
                            <input className="form-control" maxLength={32} {...register('physicianName')} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default InsurancePhysicianSection;
